import React from "react";
import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/20/solid";
import { UserCircleIcon } from "@heroicons/react/24/outline";

const DashboardPatientCards = ({ patienten, goToDetails }) => {
  if (!patienten?.length) {
    return (
      <p className="rounded-xl border border-dashed border-wa-border bg-wa-panel/50 py-12 text-center text-sm text-wa-muted">
        Geen patiënten gevonden. Pas je zoekopdracht aan.
      </p>
    );
  }

  return (
    <ul
      role="list"
      className="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3 lg:gap-4 xl:grid-cols-4"
    >
      {patienten.map((person, index) => (
        <li
          key={person.userdetails_email || person.userdetails_user_id}
          style={{ animationDelay: `${Math.min(index * 70, 420)}ms` }}
          className="group flex flex-col overflow-hidden rounded-xl border border-wa-border/80 bg-wa-panel2 text-center opacity-0 shadow-md shadow-black/5 animate-patient-card-in motion-reduce:animate-none motion-reduce:opacity-100 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-black/10"
        >
          <button
            type="button"
            onClick={() => goToDetails(person)}
            className="flex flex-1 flex-col items-center px-4 pb-3 pt-5 text-center sm:px-5 sm:pb-4 sm:pt-6"
          >
            {person?.userdetails_avatar ? (
              <img
                className="h-24 w-24 flex-none rounded-full object-cover ring-2 ring-wa-border sm:h-28 sm:w-28"
                src={person?.userdetails_avatar}
                alt={person?.userdetails_full_name || "Patiënt"}
              />
            ) : (
              <UserCircleIcon
                className="h-24 w-24 text-wa-muted sm:h-28 sm:w-28"
                aria-hidden="true"
              />
            )}
            <h3 className="mt-4 line-clamp-2 text-sm font-semibold text-wa-text sm:mt-5">
              {person?.userdetails_full_name}
            </h3>
            <div className="mt-2 min-h-[2.75rem] w-full">
              <p className="line-clamp-2 text-xs leading-relaxed text-wa-text/70">
                {person?.userdetails_klacht || "Geen klacht geregistreerd"}
              </p>
            </div>
            <span className="mt-2 inline-flex max-w-full items-center truncate rounded-full border border-wa-border bg-wa-panel px-2.5 py-1 text-[11px] font-medium text-wa-text/70">
              {person?.userdetails_email || "Geen e-mail"}
            </span>
          </button>
          <div className="mt-auto border-t border-wa-border">
            <div className="grid grid-cols-2 divide-x divide-wa-border">
              <a
                href={`mailto:${person?.userdetails_email}`}
                className="flex items-center justify-center gap-2 py-3 text-xs font-semibold text-wa-text transition-colors hover:bg-wa-hover sm:py-3.5 sm:text-sm"
                onClick={(e) => e.stopPropagation()}
              >
                <EnvelopeIcon className="h-4 w-4 shrink-0 text-wa-accent sm:h-5 sm:w-5" aria-hidden />
                Email
              </a>
              <a
                href={`tel:${person?.userdetails_phone_number}`}
                className="flex items-center justify-center gap-2 py-3 text-xs font-semibold text-wa-text transition-colors hover:bg-wa-hover sm:py-3.5 sm:text-sm"
                onClick={(e) => e.stopPropagation()}
              >
                <PhoneIcon className="h-4 w-4 shrink-0 text-wa-accent sm:h-5 sm:w-5" aria-hidden />
                Call
              </a>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default DashboardPatientCards;
